<div class="add-container">
    <div class="d-flex justify-content-between align-items-center">
        <h1 class="add-title m-0 p-0">Actualizare Informații Emitent Extern</h1>
        <button class="action-buttons-side" (click)="closeDialog()">x</button>
    </div>
    <form [formGroup]="form">
        <br>
        <div class="row">
            <div class="col-md-6">
                <mat-form-field appearance="fill">
                    <mat-label>Serie Emitent Extern</mat-label>
                    <input matInput formControlName="serie_pv" />
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field appearance="fill">
                    <mat-label>Număr Emitent Extern</mat-label>
                    <input matInput formControlName="extern_numar" />
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <mat-form-field>
                    <mat-label>Dată emitere(extern)</mat-label>
                    <input matInput [matDatepicker]="dateEmiterePicker" formControlName="extern_date_input"
                        placeholder="Dacă există..." readonly (focus)="dateEmiterePicker.open()" />
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="dateEmiterePicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateEmiterePicker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field>
                    <mat-label>Dată comunicare(extern)</mat-label>
                    <input matInput [matDatepicker]="dateComunicarePicker" formControlName="data_comunicare_pv_input"
                        readonly (focus)="dateComunicarePicker.open()" />
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="dateComunicarePicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateComunicarePicker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>

        <form [formGroup]="formExtern">
            <h3 class="m-0">Destinatar</h3>
            <mat-divider class="divider-section"></mat-divider>
            <br>
            <div class="divider-container">
                <div class="line"></div>
                <span class="text">Identificare</span>
                <div class="line"></div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Denumire Emitent Extern*</mat-label>
                        <input type="text" matInput [formControl]="entitatiExternControl"
                            [matAutocomplete]="autoEntitateExtern" (change)="onEntitateExternChange()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>

                        <mat-autocomplete #autoEntitateExtern="matAutocomplete" [displayWith]="displayEntitateExtern"
                            (optionSelected)="onEntitateExternSelected($event.option.value)">
                            <mat-option *ngIf="showEntitatiExternMessage" disabled>
                                <span *ngIf="!entitatiExternControl.value || entitatiExternControl.value.length < 2">
                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                </span>
                                <span
                                    *ngIf="isEntitatiExternLoading && entitatiExternControl.value && entitatiExternControl.value.length >= 2">Căutare...</span>
                                <span
                                    *ngIf="!isEntitatiExternLoading && entitatiExternLoadComplete && entitatiExtern.length === 0 && entitatiExternControl.value && entitatiExternControl.value.length >= 2">
                                    Nu au fost găsite rezultate
                                </span>
                            </mat-option>

                            <mat-option *ngFor="let entitate of entitatiExtern" [value]="entitate">
                                {{ entitate.denumire }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error
                            *ngIf="!formExtern.controls['denumire'].valid && formExtern.controls['denumire'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Email</mat-label>
                        <input type="text" matInput formControlName="email" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Telefon</mat-label>
                        <input type="text" matInput formControlName="telefon" />
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Țară</mat-label>
                        <input matInput [formControl]="tariExternControl" [matAutocomplete]="autoTariExtern"
                            (blur)="onTariExternBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoTariExtern="matAutocomplete" [displayWith]="displayTariExtern"
                            (optionSelected)="onTariExternChange($event.option.value)">
                            <mat-option *ngIf="filteredTariExtern.length === 0" disabled>
                                Nu au fost găsite rezultate
                            </mat-option>
                            <mat-option *ngFor="let tara of filteredTariExtern" [value]="tara">
                                {{ tara.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Județ</mat-label>
                        <input matInput [formControl]="judeteExternControl" [matAutocomplete]="autoJudeteExtern"
                            (blur)="onJudeteExternBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoJudeteExtern="matAutocomplete" [displayWith]="displayJudeteExtern"
                            (optionSelected)="onJudeteExternChange($event.option.value)">
                            <mat-option *ngIf="filteredJudeteExtern.length === 0" disabled>
                                Nu au fost găsite rezultate
                            </mat-option>
                            <mat-option *ngFor="let judet of filteredJudeteExtern" [value]="judet">
                                {{ judet.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Localitate</mat-label>
                        <input matInput [formControl]="localitatiExternControl" [matAutocomplete]="autoLocalitatiExtern"
                            (blur)="onLocalitatiExternBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoLocalitatiExtern="matAutocomplete"
                            [displayWith]="displayLocalitatiExtern"
                            (optionSelected)="onLocalitatiExternSelected($event.option.value)">
                            <mat-option *ngIf="showLocalitatiExternMessage" disabled>
                                <span
                                    *ngIf="!localitatiExternControl.value || localitatiExternControl.value.length < 2">
                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                </span>
                                <span
                                    *ngIf="isLocalitatiExternLoading && localitatiExternControl.value && localitatiExternControl.value.length >= 2">Căutare...</span>
                                <span
                                    *ngIf="!isLocalitatiExternLoading && localitatiExternLoadComplete && localitatiExtern.length === 0 && localitatiExternControl.value && localitatiExternControl.value.length >= 2">
                                    Nu au fost găsite rezultate
                                </span>
                            </mat-option>

                            <mat-option *ngFor="let localitate of localitatiExtern" [value]="localitate">
                                {{ localitate.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Sector</mat-label>
                        <mat-select formControlName="sector">
                            <mat-option value="-1">--Alegeți--</mat-option>
                            <mat-option value="1">Sector 1</mat-option>
                            <mat-option value="2">Sector 2</mat-option>
                            <mat-option value="3">Sector 3</mat-option>
                            <mat-option value="4">Sector 4</mat-option>
                            <mat-option value="5">Sector 5</mat-option>
                            <mat-option value="6">Sector 6</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-4 d-flex flex-row gap-1">
                    <mat-form-field appearance="fill">
                        <mat-label>Stradă</mat-label>
                        <input matInput [formControl]="straziExternControl" [matAutocomplete]="autoStraziExtern"
                            (blur)="onStraziExternBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoStraziExtern="matAutocomplete" [displayWith]="displayStraziExtern"
                            (optionSelected)="onStraziExternSelected($event.option.value)">
                            <mat-option *ngIf="showStraziExternMessage" disabled>
                                <span *ngIf="!straziExternControl.value || straziExternControl.value.length < 2">
                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                </span>
                                <span
                                    *ngIf="isStraziExternLoading && straziExternControl.value && straziExternControl.value.length >= 2">Căutare...</span>
                                <span
                                    *ngIf="!isStraziExternLoading && straziExternLoadComplete && straziExtern.length === 0 && straziExternControl.value && straziExternControl.value.length >= 2">
                                    Nu au fost găsite rezultate
                                </span>
                            </mat-option>

                            <mat-option *ngFor="let strada of straziExtern" [value]="strada">
                                {{ strada.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <button
                        *ngIf="!isStraziExternLoading && straziExternLoadComplete && straziExtern.length === 0 && straziExternControl.value && straziExternControl.value.length >= 2"
                        type="button" class="btn-add-entry" (click)="addStraziExtern()">
                        <i class="icon fa fa-add"></i>
                    </button>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr</mat-label>
                        <input type="text" matInput formControlName="numar" />
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-3">
                    <mat-form-field appearance="fill">
                        <mat-label>Bloc</mat-label>
                        <input type="text" matInput formControlName="bloc" />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field appearance="fill">
                        <mat-label>Scară</mat-label>
                        <input type="text" matInput formControlName="scara" />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field appearance="fill">
                        <mat-label>Apartament</mat-label>
                        <input type="text" matInput formControlName="apartament" />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field appearance="fill">
                        <mat-label>Cod Poștal</mat-label>
                        <input type="text" matInput formControlName="cod_postal" />
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <mat-form-field appearance="fill">
                        <mat-label>Observații Emitent Extern</mat-label>
                        <textarea matInput formControlName="observatii"
                            placeholder="Dacă există observații..."></textarea>
                    </mat-form-field>
                </div>
            </div>
        </form>

        <div class="row">
            <h5 class="mb-3"><span class="text-danger">*</span> <i>Câmpuri obligatorii</i></h5>
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-stroked-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid"
                    (click)="submitForm()">
                    Actualizează
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-fixed" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>